const confettiColumnNames = ['🎊', '🎉', '🎆', '🎇', '✨'];

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const matchConfettiEmoji = (str: string) =>
	confettiColumnNames.some((emoji) => str.includes(emoji));
